/**
 * portal-search.controller
 * @namespace portal
 */

(function () {
	'use strict';

	/** get the angular module and add controller */
	angular.module('nha.portal').controller('portal-search.controller', portalSearchController);

	/** setup injection */
	portalSearchController.$inject = ['$q', 'portal-search.manager', 'portal-app-context.manager', 'academicYearRepository'];

	/** implementation */
	function portalSearchController($q, portalSearchManager, portalAppContextManager, academicYearRepository) {
		/** pubic properties */
		var vm = this;
		vm.loading = false;
		vm.searching = false;
		vm.loadingMore = false;
		vm.schoolID = null;
		vm.currentSearchScope = null;
		vm.searchOptions = [];
		vm.searchString = '';
		vm.currentAcademicYearScope = null;
		vm.currentAndNextAcademicYearScope = [];
		vm.academicYears = [];
		vm.searchResultCount = 0;
		vm.searchResults = [];
		vm.searchMessage = '';

		/** private properties */
		var schoolIDs = [];
		var cancelor = null;

		/** public methods */
		vm.setSearchScope = setSearchScope;
		vm.setAcademicYearScope = setAcademicYearScope;
		vm.search = search;
		vm.clearSearch = clearSearch;

		/** run init */
		init();

		/** public method implementations */

		/** set the current search scope */
		function setSearchScope(searchOption) {
			vm.currentSearchScope = searchOption;
			clearSearch();
		}

		/** set the current academic year scope */
		function setAcademicYearScope(academicYear) {
			vm.currentAcademicYearScope = academicYear;
			clearSearch();
		}

		/** search for matches to search criteria */
		function search(hideLoader) {
			/** clear the search message */
			vm.searchMessage = '';

			/** cancel any current requests */
			if (cancelor !== null) {
				cancelor.resolve();
				cancelor = null;
			}

			/** check the length */
			if (vm.searchString.length < 3) {
				/** reset the search results */
				vm.searchResults = [];
				vm.searching = false;
				vm.loadingMore = false;
				vm.searchResultCount = 0;

				/** reset the paging options */
				portalSearchManager.resetPagingOptions();
			}

			/** check the search string length */
			if (vm.searchString.length > 2) {
				/** create cancelor promise */
				cancelor = $q.defer();

				/** clear the search message */
				vm.searchMessage = '';

				/** flip searching flag */
				if (!hideLoader) vm.searching = true;
				vm.loadingMore = true;

				/** reset the search results */
				if (!hideLoader) vm.searchResults = [];

				/** get the search method */
				var searchMethod = portalSearchManager.searchStudents;
				if (vm.currentSearchScope.type === 'staff') searchMethod = portalSearchManager.searchStaff;
				if (vm.currentSearchScope.type === 'parent') searchMethod = portalSearchManager.searchParents;

				/** execute the search method */
				searchMethod(schoolIDs, vm.currentAcademicYearScope.academicYearID, vm.searchString, cancelor).then(function(results) {
					/** check for message */
					if (!results.message) {
						/** sort results by last name */
						results.items.sort(function(a, b) {
							/** create name key */
							var keyA = a.lastName + '_' + a.firstName;
							var keyB = b.lastName + '_' + b.firstName;

							/** compare */
							if (keyA < keyB) return -1;
							if (keyA > keyB) return 1;
							return 0;
						});

						/** set the search results */
						vm.searchResults = results.items;
						vm.searchResultCount = results.count;
					} else {
						/** set the search results to blank array */
						vm.searchResults = [];

						/** set the search message */
						vm.searchMessage = results.message;
					}

					/** flip searching flag */
					vm.searching = false;
					vm.loadingMore = false;
				});
			} else {
				/** set the search results to blank array */
				vm.searchResults = [];

				/** set the search message */
				vm.searchMessage = 'You must enter at least 3 characters';
			}
		}

		/** clear the search area */
		function clearSearch() {
			/** reset search values */
			vm.searching = false;
			vm.loadingMore = false;
			vm.searchResults = [];
			vm.searchString = '';
			vm.searchMessage = '';
			vm.searchResultCount = 0;

			/** reset the paging options */
			portalSearchManager.resetPagingOptions();
		}

		/** private methods */

		/** initialize */
		function init() {
			/** flip loading flag */
			vm.loading = true;

			/** set the search options */
			vm.searchOptions = portalSearchManager.getSearchOptions();
			setSearchScope(vm.searchOptions[0]);

			/** ensure the app context */
			portalAppContextManager.ensurePortalContext().then(function(context) {
				/** set the users school ids */
				vm.schoolID = context.school.schoolID;
				schoolIDs = context.schoolIDs;

				/** get the academic years */
				academicYearRepository.getAllAcademicYears().then(function(academicYears) {
					/** set academic years */
					vm.academicYears = academicYears.reverse();

					/** get the current academic year */
					vm.currentAcademicYearScope = vm.academicYears.filter(function (ay) {
						return ay.isCurrent;
					})[0];

					vm.currentAndNextAcademicYearScope = vm.academicYears.filter(function (ay) {
						return ay.isCurrent || ay.academicYearID === (vm.currentAcademicYearScope.academicYearID + 1)
					});

					/** check for teacher */
					if (!context.roles.contains('Previous AY Student Search')) {
						vm.academicYears = vm.currentAndNextAcademicYearScope;
					}

					/** flip loading flag */
					vm.loading = false;
				});
			});
		}
	}
})();